import React from 'react';

const AllDeals = props => {
  return <div>All the deals will be here</div>;
};

AllDeals.propTypes = {};

export default AllDeals;



// WEBPACK FOOTER //
// ./src/components/deal/AllDeals.js